// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    firebaseConfig: {
      apiKey: 'AIzaSyCVpiNu0EUcZU5zWZ7x_irkHAPVPQLnvsQ',
      authDomain: 'sloshed-57a4e.firebaseapp.com',
      projectId: 'sloshed-57a4e',
      storageBucket: 'sloshed-57a4e.appspot.com',
      messagingSenderId: '709350568373',
      appId: '1:709350568373:web:9d8807777904cbe30129fc',
      measurementId: 'G-D2VVMBJL6F'
     }
  };

  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/dist/zone-error';  // Included with Angular CLI.
